import React, { useRef } from "react";
import {
  View,
  Modal,
  Animated,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
} from "react-native";
import Button from "components/Button";
import HeaderLayout from "components/HeaderLayout";

import { mq } from "utils";
import css from "styles";

interface ModalOptionsT {
  flag: boolean;
  hide: () => void;
  onDelete?: () => void;
  onArchive?: () => void;
  renderActions?: () => JSX.Element;
}

export default function ModalOPtions(props: ModalOptionsT) {
  const { flag, hide, onDelete, onArchive, renderActions } = props;

  const translateY = useRef(new Animated.Value(-100)).current;

  const _onShowModal = () =>
    Animated.timing(translateY, {
      toValue: 0,
      useNativeDriver: true,
      duration: 200,
    }).start();

  const _hide = () => {
    translateY.setValue(-100);
    hide();
  };

  const _renderActions = () => {
    if (renderActions) {
      return <>{renderActions()}</>;
    }

    return (
      <>
        {onArchive && (
          <Button
            onPress={onArchive}
            style={{ marginLeft: mq(10) }}
            width={mq(45)}
            height={mq(45)}
            bgColor="transparent"
            icon={{ name: "archive", size: 25 }}
          />
        )}
        {onDelete && (
          <Button
            onPress={onDelete}
            width={mq(45)}
            height={mq(45)}
            bgColor="transparent"
            icon={{ name: "trash", size: 25 }}
          />
        )}
      </>
    );
  };

  return (
    <Modal
      onShow={_onShowModal}
      transparent
      visible={flag}
      animationType="fade"
      onRequestClose={_hide}
    >
      <SafeAreaView style={styles.container}>
        <Animated.View style={{ transform: [{ translateY }] }}>
          <HeaderLayout removeSpace>
            <View style={styles.buttonsContainer}>
              {_renderActions()}

              <View style={{ flex: 1 }} />

              <Button
                onPress={_hide}
                width={45}
                height={45}
                bgColor="transparent"
                icon={{ name: "x", size: 25 }}
              />
            </View>
          </HeaderLayout>
        </Animated.View>
        <TouchableOpacity style={{ ...css.container }} onPress={hide} />
      </SafeAreaView>
    </Modal>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: "#00000044" },
  buttonsContainer: { flexDirection: "row-reverse" },
});
